/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Chat_ReplyInputs */

const en_start_page_chat_reply = /** @type {(inputs: Start_Page_Chat_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sure, pick a time here:`)
};

const pl_start_page_chat_reply = /** @type {(inputs: Start_Page_Chat_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jasne, wybierz godzinę tutaj:`)
};

/**
* | output |
* | --- |
* | "Sure, pick a time here:" |
*
* @param {Start_Page_Chat_ReplyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_chat_reply = /** @type {((inputs?: Start_Page_Chat_ReplyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Chat_ReplyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_chat_reply(inputs)
	return en_start_page_chat_reply(inputs)
});